var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCityCardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184901",
    "data-name": "Group 184901",
    transform: "translate(4132 3009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184899",
    "data-name": "Group 184899",
    transform: "translate(-83 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49790",
    "data-name": "Path 49790",
    d: "M19.375,31.26H.625a.63.63,0,0,1,0-1.26h18.75a.63.63,0,0,1,0,1.26Z",
    transform: "translate(-4049 -3037.26)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49791",
    "data-name": "Path 49791",
    d: "M0,0H5.351V11.674H0Z",
    transform: "translate(-4042.703 -3006.63) rotate(180)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49792",
    "data-name": "Path 49792",
    d: "M0,0H5.351V11.674H0Z",
    transform: "translate(-4029.945 -3006.63) rotate(180)",
    fill: "#7d96ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49793",
    "data-name": "Path 49793",
    d: "M15.63,3.781a.63.63,0,0,1-.63-.63V.63a.63.63,0,1,1,1.26,0V3.151A.63.63,0,0,1,15.63,3.781Z",
    transform: "translate(-4054.63 -3026)",
    fill: "#7d96ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184900",
    "data-name": "Group 184900",
    transform: "translate(-83 16.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49794",
    "data-name": "Path 49794",
    d: "M11.492,5V21.384h5.682V5Zm3.471,12.262H13.7a.63.63,0,1,1,0-1.26h1.26a.63.63,0,1,1,0,1.26Zm0-3.461H13.7a.63.63,0,1,1,0-1.26h1.26a.63.63,0,0,1,0,1.26Zm0-3.461H13.7a.63.63,0,1,1,0-1.26h1.26a.63.63,0,0,1,0,1.26Z",
    transform: "translate(-4053.333 -3028.014)",
    fill: "#7d96ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityCardicon);
export default __webpack_public_path__ + "static/media/cityCardicon.16c26c6a4edcbafb18f43b93865ef3e4.svg";
export { ForwardRef as ReactComponent };